import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77598cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100 h-75" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "js_editor",
    class: "w-100 h-100"
  })
], -1))

import { onMounted, ref } from "vue";
import "brace";
import "brace/mode/javascript";
import "brace/mode/html";
import "brace/theme/monokai";
import "brace/theme/chrome";
import { getWordCompleter } from "../../data/word_completer";
import language_tools from "brace/ext/language_tools";
import { blocklyStore } from "../../blockly/blocklyStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeModeSection',
  setup(__props) {

const ace = (window as any).ace;

/**
 * エディタ生成
 */
const editor = ref({} as any);
onMounted(() => {
  // スニペット
  const snippetManager = language_tools.snippetManager;

  // let a = "if (${1:condition_name}) {"
  // a += "  ${2:body}"
  // a += "};"

  const mySnippetText = "${1:test}.this is custom snippet text!";
  ace.config.loadModule("ace/snippets/javascript", function (m) {
    if (m) {
      snippetManager.files.javascript = m;
      m.snippetText += mySnippetText; // if you have snippets in the ace snippet format
      m.snippets = snippetManager.parseSnippetFile(m.snippetText);
      // or do this if you already have them parsed
      m.snippets.push({
        content:
          "${1:class_name}.prototype.${2:method_name} = function(${3:first_argument}) {    ${4:// body...}",
        name: "proto",
        tabTrigger: "proto",
      });
      snippetManager.register(m.snippets, m.scope);
    }
  });

  editor.value = ace.edit("js_editor") as any;
  editor.value.getSession().setMode("ace/mode/javascript");
  editor.value.setTheme("ace/theme/monokai");
  editor.value.setFontSize(18);
  editor.value.focus();
  editor.value.setOptions({
    enableBasicAutocompletion: true,
    enableSnippets: true,
    enableLiveAutocompletion: true,
  });
  editor.value.setValue(blocklyStore.js_code || "");
  editor.value.on("change", () => {
    blocklyStore.js_code = editor.value.getValue();
  });

  editor.value.commands.addCommand({
    name: "save",
    bindKey: { win: "Ctrl-S", mac: "Command-S" },
    exec: async () => {
      await blocklyStore.save();
    },
    readOnly: true, // false if this command should not apply in readOnly mode
  });

  // const customSnippetText = ['snippet log', "	console.log('${1:}')", ''].join('\n');
  // const customSnippet = snippetManager.parseSnippetFile(customSnippetText, 'sql');
  // snippetManager.register(customSnippet, 'sql');

  // コード補完（静的）
  const staticWordCompleter = {
    getCompletions: (editor, session, pos, prefix, cb) => {
      const wordList = getWordCompleter();
      cb(
        null,
        wordList.map((item) => {
          // return {
          //   content: item.value,
          //   name: item.meta,
          //   tabTrigger: "Animation",
          // };
          return {
            caption: item.word,
            value: item.word,
            meta: "blockvrock",
          };
        })
      );
    },
  };
  // editor.value.getCompleters([staticWordCompleter]);
  if (!editor.value.completer) {
    // make sure completer is initialized
    editor.value.execCommand("startAutocomplete");
    editor.value.completer.detach();
  }
  editor.value.completer.popup.container.style.width = "50%";
  // editor.value.completer.popup.container.classList.add("foo");
  editor.value.completers = [staticWordCompleter];
});

const insertText = (e) => {
  // console.log(e.target.textContent);
  editor.value.session.insert(editor.value.getCursorPosition(), e.target.textContent);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex" }, [
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "!"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "\""),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "'"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "("),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, ")"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, ";"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "/"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "."),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, ","),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "<"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, ">"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "="),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "+"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "-"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "*"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "\\"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "|"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "&"),
      _createElementVNode("button", {
        class: "btn btn-info keybtn me-1",
        onClick: insertText
      }, "@")
    ]),
    _hoisted_2
  ]))
}
}

})